var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "columns m-0" },
    [
      _c("div", { staticClass: "column is-half p-0 pr-3" }, [
        _c("article", { staticClass: "box" }, [
          _c("div", { staticClass: "columns is-gapless" }, [
            _vm._m(0),
            _vm.activeInvoice
              ? _c("div", { staticClass: "column is-narrow" }, [
                  _c("div", { staticClass: "tags" }, [
                    _c(
                      "span",
                      { staticClass: "tag is-success is-pulled-right" },
                      [
                        _vm._v(
                          "Inv " +
                            _vm._s(
                              `${_vm.activeInvoice.prefix}${_vm.activeInvoice.invoiceNo}${_vm.activeInvoice.suffix}`
                            ) +
                            " dated " +
                            _vm._s(
                              _vm.$filters.formatDateTimezone(
                                _vm.activeInvoice.invoiceDate,
                                _vm.$userInfo.locale
                              )
                            )
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Quote No.")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  staticClass: "input is-static",
                  attrs: {
                    type: "text",
                    placeholder: "Quote No.",
                    readonly: "",
                  },
                  domProps: {
                    value: `${_vm.innerValue.prefix}${_vm.innerValue.miscQuoteNo}${_vm.innerValue.suffix}`,
                  },
                }),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "field is-narrow" },
              [
                _c("label", { staticClass: "label" }, [_vm._v("Quote Date")]),
                _vm.readOnlyView
                  ? _c("input", {
                      staticClass: "input is-static",
                      attrs: { readonly: "" },
                      domProps: {
                        value: _vm.$filters.formatDateTimezone(
                          _vm.quoteDate,
                          _vm.$userInfo.locale
                        ),
                      },
                    })
                  : _c("v-date-picker", {
                      attrs: {
                        "is-dark": _vm.$theme.isDark,
                        masks: _vm.formats,
                        attributes: _vm.attrs,
                        locale: _vm.$userInfo.locale,
                        timezone: _vm.$filters.getIanaTimezone(),
                      },
                      on: {
                        input: function ($event) {
                          _vm.selectedQuoteDate =
                            _vm.$filters.fromISOWithCurrentTime(
                              $event.toISOString()
                            )
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c("div", { staticClass: "field" }, [
                                _c(
                                  "div",
                                  { staticClass: "control has-icons-left" },
                                  [
                                    _c(
                                      "input",
                                      _vm._g(
                                        {
                                          staticClass: "input",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Quote Date",
                                            readonly: "",
                                          },
                                          domProps: { value: inputValue },
                                        },
                                        inputEvents
                                      )
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "icon is-small is-left" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-calendar mdi-18px",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.selectedQuoteDate,
                        callback: function ($$v) {
                          _vm.selectedQuoteDate = $$v
                        },
                        expression: "selectedQuoteDate",
                      },
                    }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "is-divider" }),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Customer")]),
            (_vm.gstPaid || _vm.readOnlyView) && _vm.selectedCustomer
              ? _c("div", { staticClass: "field" }, [
                  _c("input", {
                    staticClass: "input is-static",
                    attrs: { readonly: "" },
                    domProps: { value: _vm.selectedCustomer.customerName },
                  }),
                ])
              : !_vm.gstPaid && !_vm.readOnlyView
              ? _c("div", { staticClass: "field has-addons" }, [
                  _c(
                    "div",
                    { staticClass: "control is-expanded" },
                    [
                      _vm.activeCustomers
                        ? _c(
                            "multiselect",
                            {
                              class: {
                                "is-danger": _vm.$v.entity.customerId.$error,
                              },
                              attrs: {
                                "deselect-label": "Can't remove this value",
                                "track-by": "assetId",
                                label: "assetName",
                                placeholder: "Select a customer",
                                options: _vm.activeCustomers,
                                loading: _vm.isCustomerLoading,
                                "internal-search": false,
                                "options-limit": _vm.customerFilter.pageSize,
                                searchable: true,
                                "show-labels": false,
                                "allow-empty": true,
                              },
                              on: {
                                select: _vm.selectCustomer,
                                remove: _vm.removeCustomer,
                                "search-change": _vm.getCustomerDropdownFilter,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "option",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "tag is-pulled-right",
                                            class: {
                                              "is-success":
                                                props.option.assetType == 1,
                                              "is-info":
                                                props.option.assetType == 4,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  props.option.assetType == 1
                                                    ? "Customer"
                                                    : "Insurer"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(`${props.option.assetName}`)
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2502510241
                              ),
                              model: {
                                value: _vm.selectedCustomer,
                                callback: function ($$v) {
                                  _vm.selectedCustomer = $$v
                                },
                                expression: "selectedCustomer",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "has-text-danger",
                                  attrs: { slot: "noResult" },
                                  slot: "noResult",
                                },
                                [_vm._v("Customer not found.")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.selectedCustomer && !_vm.selectedCustomer.active
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v("Customer has been set to inactive."),
                          ])
                        : _vm._e(),
                      _vm.$v.entity && !_vm.$v.entity.customerId.validGuid
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v("Customer is required."),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button",
                        class: _vm.assetButtonClass,
                        attrs: { disabled: _vm.gstPaid || _vm.readOnlyView },
                        on: {
                          click: function ($event) {
                            return _vm.onEditAddCustomer()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", {
                            staticClass: "mdi mdi-24px",
                            class: _vm.assetButtonIconClass,
                          }),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Contact")]),
            _vm.gstPaid || _vm.readOnlyView
              ? _c("div", { staticClass: "field" }, [
                  _c("input", {
                    staticClass: "input is-static",
                    attrs: { readonly: "" },
                    domProps: {
                      value: _vm.selectedContact
                        ? _vm.selectedContact.fullname
                        : "",
                    },
                  }),
                ])
              : _c("div", { staticClass: "field has-addons" }, [
                  _c(
                    "div",
                    { staticClass: "control is-expanded" },
                    [
                      _c(
                        "multiselect",
                        {
                          attrs: {
                            "track-by": "contactId",
                            label: "fullname",
                            placeholder: "Select a contact",
                            options: _vm.activeContacts,
                            searchable: true,
                            "show-labels": false,
                            "allow-empty": true,
                          },
                          on: {
                            select: _vm.selectContact,
                            remove: _vm.removeContact,
                            "search-change": _vm.onContactSearchChange,
                          },
                          nativeOn: {
                            input: function ($event) {
                              return _vm.captureContactInput.apply(
                                null,
                                arguments
                              )
                            },
                          },
                          model: {
                            value: _vm.selectedContact,
                            callback: function ($$v) {
                              _vm.selectedContact = $$v
                            },
                            expression: "selectedContact",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "has-text-danger",
                              attrs: { slot: "noResult" },
                              slot: "noResult",
                            },
                            [_vm._v("Contact not found.")]
                          ),
                        ]
                      ),
                      _vm.selectedContact && !_vm.selectedContact.active
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v("Contact has been set to inactive."),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button",
                        class: _vm.contactButtonClass,
                        attrs: {
                          disabled:
                            !_vm.hasAssetSelected ||
                            _vm.gstPaid ||
                            _vm.readOnlyView,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onEditAddContact()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", {
                            staticClass: "mdi mdi-24px",
                            class: _vm.contactButtonIconClass,
                          }),
                        ]),
                      ]
                    ),
                  ]),
                ]),
          ]),
          _c("div", { staticClass: "is-divider" }),
          _c("label", { staticClass: "label" }, [_vm._v("Items")]),
          _c(
            "table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
            },
            [
              _vm._m(1),
              _c("tfoot", { staticClass: "has-multiple-totals no-border" }, [
                _c(
                  "tr",
                  {
                    staticClass: "has-border-bottom-4",
                    class: `misc-quote-background-text-${_vm.$theme.name}`,
                  },
                  [
                    _vm._m(2),
                    _c("th", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.innerValue.total - _vm.innerValue.gst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "tr",
                  {
                    staticClass: "has-border-bottom-4",
                    class: `misc-quote-background-primary-${_vm.$theme.name}`,
                  },
                  [
                    _c("th", { staticClass: "has-text-left" }, [
                      _vm._v("GST "),
                      _c("span", { staticClass: "subtext" }, [
                        _vm._v("(" + _vm._s(_vm.innerValue.gstRate) + "%)"),
                      ]),
                    ]),
                    _c("th", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.innerValue.gst,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "tr",
                  { class: `misc-quote-background-success-${_vm.$theme.name}` },
                  [
                    _vm._m(3),
                    _c("th", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.innerValue.total,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm.activeItems.length > 0
                ? _c(
                    "tbody",
                    _vm._l(_vm.activeItems, function (item) {
                      return _c("tr", { key: item.miscQuoteItemId }, [
                        _c("td", [_vm._v(_vm._s(item.itemDesc))]),
                        _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                item.quantity * item.unitPrice,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]),
                      ])
                    }),
                    0
                  )
                : _c("tbody", [_vm._m(4)]),
            ]
          ),
          !_vm.innerValue.isNew && !_vm.readOnlyView
            ? _c("div", [
                _c("div", { staticClass: "is-divider" }),
                _c("div", { staticClass: "buttons has-addons is-centered" }, [
                  _c(
                    "span",
                    {
                      staticClass: "button",
                      class: {
                        "is-success is-selected": !_vm.innerValue.deleted,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleActive(true)
                        },
                      },
                    },
                    [_vm._m(5), _c("span", [_vm._v("Active")])]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "button",
                      class: {
                        "is-danger is-selected": _vm.innerValue.deleted,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toggleActive(false)
                        },
                      },
                    },
                    [_vm._m(6), _c("span", [_vm._v("In-Active")])]
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "column is-half p-0 is-flex" }, [
        _c("article", { staticClass: "box is-flex-grow-1" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Remarks")]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Reference")]),
            _c("div", { staticClass: "control" }, [
              !_vm.readOnlyView
                ? _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.innerValue.reference,
                        expression: "innerValue.reference",
                      },
                    ],
                    staticClass: "textarea",
                    attrs: {
                      placeholder: "",
                      maxlength: "200",
                      disabled: _vm.readOnlyView,
                    },
                    domProps: { value: _vm.innerValue.reference },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.innerValue,
                          "reference",
                          $event.target.value
                        )
                      },
                    },
                  })
                : _c("span", [_vm._v(_vm._s(_vm.innerValue.reference))]),
            ]),
          ]),
          !_vm.readOnlyView
            ? _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control is-pulled-right" }, [
                  _c("div", { staticClass: "is-pulled-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-small is-success tooltip",
                        attrs: { "data-tooltip": "Add Remarks" },
                        on: {
                          click: function ($event) {
                            return _vm.toggleRemarkModal()
                          },
                        },
                      },
                      [_vm._m(7), _c("span", [_vm._v("Remarks")])]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Remarks")]),
            _c(
              "table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
              },
              [
                _c("thead"),
                _vm.activeRemarks.length > 0
                  ? _c(
                      "tbody",
                      _vm._l(_vm.activeRemarks, function (remark, index) {
                        return _c("tr", { key: remark.remarkId }, [
                          _c("td", { staticClass: "is-content-width" }, [
                            _c("span", { staticClass: "tag is-info" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$filters.formatDateTimeLocale(
                                    remark.remarkDateTime,
                                    _vm.$userInfo.locale
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm.readOnlyView
                            ? _c("td", [
                                _c("div", { staticClass: "control" }, [
                                  _c("span", [_vm._v(_vm._s(remark.remarks))]),
                                ]),
                              ])
                            : _c("td", [
                                _c("div", { staticClass: "control" }, [
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: remark.remarks,
                                        expression: "remark.remarks",
                                      },
                                    ],
                                    staticClass: "textarea",
                                    attrs: { rows: "3", placeholder: "" },
                                    domProps: { value: remark.remarks },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          remark,
                                          "remarks",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                              ]),
                          !_vm.readOnlyView
                            ? _c(
                                "td",
                                {
                                  staticClass:
                                    "has-text-centered is-content-width has-vertical-middle",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button is-danger is-small is-inverted",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteRemark(
                                            remark,
                                            index,
                                            _vm.remarkTypes.Remark
                                          )
                                        },
                                      },
                                    },
                                    [_vm._m(8, true)]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      }),
                      0
                    )
                  : _c("tbody", [_vm._m(9)]),
              ]
            ),
          ]),
          !_vm.readOnlyView
            ? _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control is-pulled-right" }, [
                  _c("div", { staticClass: "is-pulled-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-small is-success tooltip",
                        attrs: { "data-tooltip": "Add Remarks" },
                        on: {
                          click: function ($event) {
                            return _vm.toggleRemarkModal()
                          },
                        },
                      },
                      [_vm._m(10), _c("span", [_vm._v("Remarks")])]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [_vm._v("Printed Remarks")]),
            _c(
              "table",
              {
                staticClass:
                  "table is-bordered is-striped is-narrow is-fullwidth",
              },
              [
                _c("thead"),
                _vm.activePrintedRemarks.length > 0
                  ? _c(
                      "tbody",
                      _vm._l(
                        _vm.activePrintedRemarks,
                        function (remark, index) {
                          return _c("tr", { key: remark.remarkId }, [
                            _c("td", { staticClass: "is-content-width" }, [
                              _c("span", { staticClass: "tag is-info" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimeLocale(
                                      remark.remarkDateTime,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm.readOnlyView
                              ? _c("td", [
                                  _c("div", { staticClass: "control" }, [
                                    _c("span", [
                                      _vm._v(_vm._s(remark.remarks)),
                                    ]),
                                  ]),
                                ])
                              : _c("td", [
                                  _c("div", { staticClass: "control" }, [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: remark.remarks,
                                          expression: "remark.remarks",
                                        },
                                      ],
                                      staticClass: "textarea",
                                      attrs: { rows: "3", placeholder: "" },
                                      domProps: { value: remark.remarks },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            remark,
                                            "remarks",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                                ]),
                            !_vm.readOnlyView
                              ? _c(
                                  "td",
                                  {
                                    staticClass:
                                      "has-text-centered is-content-width has-vertical-middle",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "button is-danger is-small is-inverted",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteRemark(
                                              remark,
                                              index,
                                              _vm.remarkTypes.PrintedRemark
                                            )
                                          },
                                        },
                                      },
                                      [_vm._m(11, true)]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        }
                      ),
                      0
                    )
                  : _c("tbody", [_vm._m(12)]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm.value && _vm.isRemarkModalActive
        ? _c(
            "remark-modal",
            {
              attrs: {
                "show-remark": true,
                "show-printed-remark": true,
                "show-recurring-remark": true,
                active: _vm.isRemarkModalActive,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isRemarkModalActive = $event
                },
                add: _vm.addRemarks,
                cancel: function ($event) {
                  return _vm.toggleRemarkModal()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Add Quick Invoice Remarks"),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v(" Details ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Description")]),
        _c("th", { staticClass: "has-text-right" }, [_vm._v(" Total ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "has-text-left" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "has-text-left" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Inc GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "has-text-centered", attrs: { colspan: "3" } }, [
        _c("span", { attrs: { icon: "icon is-medium" } }, [
          _c("i", {
            staticClass:
              "mdi mdi-36px mdi-dots-horizontal mdi-inactive-color mdi-inactive",
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "has-text-centered", attrs: { colspan: "2" } }, [
        _c("span", { attrs: { icon: "icon is-medium" } }, [
          _c("i", {
            staticClass:
              "mdi mdi-36px mdi-comment-text-outline mdi-inactive-color mdi-inactive",
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "has-text-centered", attrs: { colspan: "2" } }, [
        _c("span", { attrs: { icon: "icon is-medium" } }, [
          _c("i", {
            staticClass:
              "mdi mdi-36px mdi-comment-text-outline mdi-inactive-color mdi-inactive",
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }